module.exports = __webpack_public_path__ + "static/img/download.090ba080.svg";